import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { defaultPropsDecorator } from 'substyle';
import { create } from 'css-jss';
import mapPseudoSelectors from './mapPseudoSelectors';

var createPropsDecorator = function createPropsDecorator(jss) {
  var css = create(jss);

  var decorateProps = function decorateProps(stylingProps) {
    var decoratedStylingProps = defaultPropsDecorator(stylingProps);

    var style = decoratedStylingProps.style,
        className = decoratedStylingProps.className,
        rest = _objectWithoutProperties(decoratedStylingProps, ["style", "className"]);

    if (!style) {
      return decoratedStylingProps;
    }

    var generatedClassName = css(mapPseudoSelectors(style));
    return _objectSpread({
      className: className ? "".concat(className, " ").concat(generatedClassName) : generatedClassName
    }, rest);
  };

  return decorateProps;
};

export default createPropsDecorator;